import { render, staticRenderFns } from "./AddInbox.vue?vue&type=template&id=15f89017&scoped=true&"
import script from "./AddInbox.vue?vue&type=script&lang=js&"
export * from "./AddInbox.vue?vue&type=script&lang=js&"
import style0 from "./AddInbox.vue?vue&type=style&index=0&id=15f89017&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f89017",
  null
  
)

export default component.exports